/* =========================================================
   cart.api.js
   AJAX SPIN CART + CART DRAWER
   ========================================================= */


/* =========================================================
   ITEM ADDED
   ========================================================= */

Shopify.onItemAdded = function(line_item) {

  /*
   * Refresh cart information
   */
  Shopify.getCart();

  /*
   * Open the EXISTING cart drawer.
   *
   * This is the same button used when the customer
   * manually clicks the cart icon in the header.
   */
  setTimeout(function() {

    jQuery('#offcanvas-cart-icon').trigger('click');

  }, 300);

};


/* =========================================================
   CART UPDATE
   ========================================================= */

Shopify.onCartUpdate = function(cart) {

  Shopify.cartUpdateInfo(
    cart,
    '.single-cart-item-loop'
  );

};


/* =========================================================
   ERROR HANDLER
   ========================================================= */

Shopify.onError = function(XMLHttpRequest, textStatus) {

  var data = eval(
    '(' + XMLHttpRequest.responseText + ')'
  );

  if (!!data.message) {

    var str = data.description;

  } else {

    var str =
      'Error : ' +
      Shopify.fullMessagesFromErrors(data).join('; ') +
      '.';

  }

  jQuery('.error_message').text(str);

  /*
   * Error popup only.
   *
   * This is NOT the successful Add To Cart popup.
   */
  jQuery('#modalAddToCartError').modal('toggle');

  setTimeout(function() {

    jQuery('.shopping__cart')
      .removeClass('shopping__cart__on');

    jQuery('.body__overlay')
      .removeClass('is-visible');

  }, 2000);

};


/* =========================================================
   ADD ITEM
   ========================================================= */

Shopify.addItem = function(
  variant_id,
  quantity,
  callback
) {

  var quantity = quantity || 1;

  var params = {

    type: 'POST',

    url: '/cart/add.js',

    data:
      'quantity=' +
      quantity +
      '&id=' +
      variant_id,

    dataType: 'json',

    success: function(line_item) {

      /*
       * If a callback was supplied, use it.
       */
      if (typeof callback === 'function') {

        callback(line_item);

      }

      /*
       * Otherwise use the normal Add To Cart flow.
       *
       * IMPORTANT:
       * There is NO cartPopap() here.
       */
      else {

        Shopify.onItemAdded(line_item);

      }

    },

    error: function(
      XMLHttpRequest,
      textStatus
    ) {

      Shopify.onError(
        XMLHttpRequest,
        textStatus
      );

    }

  };

  jQuery.ajax(params);

};


/* =========================================================
   ADD ITEM FROM FORM
   ========================================================= */

Shopify.addItemFromForm = function(
  form_id,
  variant_id,
  callback
) {

  var params = {

    type: 'POST',

    url: '/cart/add.js',

    beforeSend: function() {

      /*
       * Quick View loading state
       */
      if (form_id == 'add-item-qv') {

        jQuery('#' + form_id)
          .find('.addtocartqv')
          .html(
            jQuery(
              '.quickViewModal_info .button_wait'
            ).html()
          );

      }

    },

    data: jQuery('#' + form_id).serialize(),

    dataType: 'json',

    success: function(line_item) {

      /*
       * Callback supplied by another function
       */
      if (typeof callback === 'function') {

        callback(line_item);

      }

      /*
       * Normal Add To Cart flow
       */
      else {

        /*
         * QUICK VIEW
         *
         * Keep the existing button animation.
         */
        if (form_id == 'add-item-qv') {

          jQuery('#' + form_id)
            .find('.addtocartqv')
            .html(
              jQuery(
                '.quickViewModal_info .button_added'
              ).html()
            );

          jQuery('#' + form_id)
            .find('.addtocartqv')
            .addClass(
              'added_in_cart'
            );

          setTimeout(function() {

            jQuery('#' + form_id)
              .find('.addtocartqv')
              .removeClass(
                'added_in_cart'
              );

            jQuery('#' + form_id)
              .find('.addtocartqv')
              .html(
                jQuery(
                  '.quickViewModal_info .button'
                ).html()
              );

          }, 2000);

        }


        /*
         * IMPORTANT
         *
         * We do NOT call:
         *
         * Shopify.cartPopapForm()
         *
         * The successful Add To Cart event goes to
         * onItemAdded(), which refreshes the cart and
         * opens the existing drawer.
         */
        Shopify.onItemAdded(line_item);

      }

    },

    error: function(
      XMLHttpRequest,
      textStatus
    ) {

      /*
       * NORMAL PRODUCT FORM ERROR
       */
      if (form_id != 'add-item-qv') {

        Shopify.onError(
          XMLHttpRequest,
          textStatus
        );

      }


      /*
       * QUICK VIEW ERROR
       */
      else {

        jQuery('#' + form_id)
          .find('.addtocartqv')
          .html(
            jQuery(
              '.quickViewModal_info .button_error'
            ).html()
          );

        jQuery('#' + form_id)
          .find('.addtocartqv')
          .addClass(
            'error_in_cart'
          );

        setTimeout(function() {

          jQuery('#' + form_id)
            .find('.addtocartqv')
            .removeClass(
              'error_in_cart'
            );

          jQuery('#' + form_id)
            .find('.addtocartqv')
            .html(
              jQuery(
                '.quickViewModal_info .button'
              ).html()
            );

        }, 2000);

      }

    }

  };

  jQuery.ajax(params);

};


/* =========================================================
   ADD ITEM FROM FORM START
   ========================================================= */

Shopify.addItemFromFormStart = function(
  form,
  product_id
) {

  Shopify.addItemFromForm(
    form,
    product_id
  );

};


/* =========================================================
   OLD POPUP FUNCTIONS
   =========================================================
   
   These functions are kept so that any old theme code
   referencing them does not cause a JavaScript error.

   THEY DO NOT OPEN THE POPUP.
   ========================================================= */

Shopify.cartPopap = function(
  variant_id
) {

  /*
   * OLD SUCCESS POPUP DISABLED.
   *
   * Cart drawer is opened by onItemAdded().
   */

};


Shopify.cartPopapForm = function(
  variant_id
) {

  /*
   * OLD SUCCESS POPUP DISABLED.
   *
   * Cart drawer is opened by onItemAdded().
   */

};


/* =========================================================
   CART UPDATE INFO
   ========================================================= */

Shopify.cartUpdateInfo = function(
  cart,
  cart_cell_id
) {

  var formatMoney = window.money_format;


  if (typeof cart_cell_id === 'string') {

    var cart_cell = jQuery(
      cart_cell_id
    );


    if (cart_cell.length) {

      cart_cell.empty();


      jQuery.each(
        cart,
        function(key, value) {

          if (key === 'items') {


            /* =============================================
               CART HAS ITEMS
               ============================================= */

            if (value.length) {

              jQuery(
                '.single-product-cart, ' +
                '.item-multiple-item-count, ' +
                '.cart-product-wrapper'
              ).css({
                'display': 'block'
              });


              jQuery(
                '.single-cart-product.empty, ' +
                '.item-single-item-count'
              ).css({
                'display': 'none'
              });


              var table = jQuery(
                cart_cell_id
              );


              jQuery.each(
                value,
                function(i, item) {


                  /*
                   * Theme originally displays maximum
                   * 20 products.
                   */
                  if (i > 19) {

                    return false;

                  }


                  jQuery(
                    '<div class="single-cart-product">' +

                      '<span class="cart-close-icon">' +

                        '<a ' +
                        'href="javascript:void(0);" ' +
                        'onclick="Shopify.removeItem(' +
                        item.variant_id +
                        ')">' +

                          '<i class="ti-close"></i>' +

                        '</a>' +

                      '</span>' +


                      '<div class="image">' +

                        '<a href="' +
                        item.url +
                        '">' +

                          '<img src="' +
                          item.image +
                          '" class="img-fluid" alt="">' +

                        '</a>' +

                      '</div>' +


                      '<div class="content">' +

                        '<h5>' +

                          '<a href="' +
                          item.url +
                          '">' +

                            item.title +

                          '</a>' +

                        '</h5>' +


                        '<p>' +

                          '<span class="cart-count">' +

                            item.quantity +

                            ' x ' +

                          '</span>' +


                          '<span class="discounted-price">' +

                            Shopify.formatMoney(
                              item.price,
                              formatMoney
                            ) +

                          '</span>' +

                        '</p>' +

                      '</div>' +


                    '</div>'

                  ).appendTo(table);


                }
              );


            }


            /* =============================================
               CART EMPTY
               ============================================= */

            else {

              jQuery(
                '.single-product-cart, ' +
                '.item-single-item-count, ' +
                '.cart-product-wrapper'
              ).css({
                'display': 'none'
              });


              jQuery(
                '.single-cart-product.empty'
              ).css({
                'display': 'block'
              });

            }

          }

        }
      );

    }

  }


  /* =======================================================
     UPDATE CART TOTAL
     ======================================================= */

  changeHtmlValue(
    '.shopping-cart__total',
    Shopify.formatMoney(
      cart.total_price,
      formatMoney
    )
  );


  /* =======================================================
     UPDATE CART ITEM COUNT
     ======================================================= */

  changeHtmlValue(
    '.bigcounter',
    cart.item_count
  );


  /* =======================================================
     REFRESH CURRENCY
     ======================================================= */

  jQuery(
    '.currency .active'
  ).trigger('click');

};


/* =========================================================
   UTILITY FUNCTION
   ========================================================= */

function changeHtmlValue(
  cell,
  value
) {

  var $cartLinkText = jQuery(cell);

  $cartLinkText.html(value);

}